module.exports = __webpack_public_path__ + "static/media/LlamSuaValues.c1ef3aeb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/LlamSuaValues.jpg
// module id = 955
// module chunks = 0